import { ServiceResult } from '../models';
import {
  CreateRecipeCustomerUserManageRequest,
  DeleteRecipeCustomerUserManageRequest,
  RecipeCustomerUserManage,
  UpdateRecipeCustomerUserManagesRequest,
} from '../models/recipe-customer-user-manage.models';
import ApiService from './api-service';

class RecipeCustomerUserManageService extends ApiService {
  private static classInstance: RecipeCustomerUserManageService;

  private constructor() {
    super('RecipeCustomerUserManage');
  }

  public static getInstance(): RecipeCustomerUserManageService {
    if (!this.classInstance) {
      this.classInstance = new RecipeCustomerUserManageService();
    }
    return this.classInstance;
  }

  public getRecipeCustomerUserManage(recipeCustomerUserManageId: string): ServiceResult<RecipeCustomerUserManage> {
    return this.get(
      `${this.baseUrl}/GetRecipeCustomerUserManage?recipeCustomerUserManageId=${recipeCustomerUserManageId}`
    );
  }

  public getRecipeCustomerUserManages(customerId: string): ServiceResult<RecipeCustomerUserManage[]> {
    return this.get(`${this.baseUrl}/GetRecipeCustomerUserManages?customerId=${customerId}`);
  }

  public updateRecipeCustomerUserManages(request: UpdateRecipeCustomerUserManagesRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/UpdateRecipeCustomerUserManages`, request);
  }

  public createRecipeCustomerUserManage(
    request: CreateRecipeCustomerUserManageRequest
  ): ServiceResult<RecipeCustomerUserManage> {
    return this.post(`${this.baseUrl}/CreateRecipeCustomerUserManage`, request);
  }

  public deleteRecipeCustomerUserManage(request: DeleteRecipeCustomerUserManageRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeCustomerUserManage`, request);
  }
}

export default RecipeCustomerUserManageService;
